export const PAYMENT_HISTORY_COLLECTION = "payment_history";
